import React, {Component} from "react";


class AppHeader extends Component {
    render() {
        return (
            <header className="navbar app-header">
                <section className="navbar-section">
                </section>
                <section className="navbar-center">
                    <img src="/images/pygmalios_live.png" alt="Pygmalios" className="app-logo"/>
                </section>
                <section className="navbar-section">
                </section>
            </header>
        );
    }
}

export default AppHeader;